import $ from "../libs/jquery-3.5.1.min.js";
import "../libs/css_browser_selector.js";
import {Anim} from "./Anim.js";
import A from "../libs/aladin/aladin.js";

import DataTable from 'datatables.net-dt';

require('datatables.net-buttons');
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-buttons/js/buttons.html5.js')
require('datatables.net-buttons/js/buttons.print.js')

let table;

export class MainApp {

  constructor() {

    this.anim = new Anim()
    this.anim.attach();

    $(window).off("resize").on("resize", $.proxy(function () {
      this.resize();
    }, this));

    $("#search-results-wrapper .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/search", "#search-results-wrapper", this.buildResultsPage, {
        "search-type": $(n).data("type"),
        "search-query": $(n).data("query"),
      }).then((data) => {

        // Find moca_aid
        const moca_aid_field = data[0] && data[0].data.find((el) => {
          return el.label === "moca_aid: ";
        })

        // Load figures using aid
        if (moca_aid_field) {
          $("#association-image-wrapper .results").each($.proxy(function (i, n) {
            const url = $(n).data("image-endpoint") + "/" + moca_aid_field.value;
            const wrapperSelector = "#" + $(n).parent().attr("id")
            this.apiRequest(url, wrapperSelector, (data, destination) => {
              $(destination).append(`<div class="image-wrapper"><img src='${data.url}/download'></div>`)
            }, {}, "get")
          }, this));
        }

        if ($(n).data("type") == "star") {

          // Find location
          const moca_ra_deg = data[0] && data[0].data.find((el) => {
            return el.label === "R.A. (deg) : ";
          })?.value;
          const moca_decl_deg = data[0] && data[0].data.find((el) => {
            return el.label === "Decl. (deg) : ";
          })?.value;

          // Init aladin
          if (moca_ra_deg && moca_decl_deg) {
            let aladin;
            A.init.then(() => {
              const target = `${moca_ra_deg} ${moca_decl_deg}`;
              aladin = A.aladin('#aladin-lite-div-1', {survey: "P/DSS2/color", fov: 0.15, target: target});
              aladin = A.aladin('#aladin-lite-div-2', {survey: "CDS/P/unWISE/color-W2-W1W2-W1", fov: 0.15, target: target});
            });
          }
        }
      })
    }, this));

    $("#db-schema-wrapper .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/schema", "#db-schema-wrapper", this.buildResultsPage, {
        "table": $(n).data("table")
      })
    }, this));

    $("#associations-wrapper .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/associations", "#associations-wrapper", this.buildResultsPage)
    }, this));

    $("#overview .results").each($.proxy(function (i, n) {
      const url = $(n).data("image-endpoint");
      const wrapperSelector = "#" + $(n).parent().attr("id")
      this.apiRequest(url, wrapperSelector, (data, destination) => {
        $(destination).append(`<div class="image-wrapper"><img src='${data.url}/download'></div>`)
      }, {}, "get")
    }, this));

    if ($("#overview").length > 0) {
      this.apiRequest("/api/query", null, (data, destination) => {
        $("#overview .placeholder").each((i, n) => {
          const targetField = $(n).data("placeholder-for");
          const value = (data[0]) ? data[0][targetField] : null;
          if (value) $(n).html(value)
        });
      }, {
        "query": "SELECT " +
          "(SELECT FORMAT(COUNT(*),0) AS num_asso FROM moca_associations WHERE suboptimal_grouping=0 AND is_real != 0) as num_asso," +
          "(SELECT FORMAT(COUNT(*),0) AS age_count FROM data_association_ages) AS age_count," +
          "(SELECT FORMAT(COUNT(*),0) AS num_object FROM moca_objects) as num_object," +
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_l0 FROM cdata_spectral_types cspt WHERE cspt.adopted=1 AND cspt.spectral_type_number >= 10 AND cspt.photometric_estimate=0) AS num_l0,"+
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_bd FROM cdata_spectral_types cspt WHERE cspt.adopted=1 AND cspt.photometric_estimate=0 AND ((cspt.spectral_type_number >= 10) OR (cspt.spectral_type_number >= 6 AND (cspt.gravity_class REGEXP 'INT|VL|β|γ|δ' OR cspt.suffix REGEXP 'red|young')))) AS num_bd,"+
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_members FROM data_memberships dm WHERE dm.moca_mtid != 'R') AS num_members",
        "offset": 0,
        "limit": 10,
      }, "post")
    }

    $("#moca-disk-space .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/disk", "#moca-disk-space", (data, destination) => {
        const usagePercentage = (data.usage * 100).toFixed(2) + "%";
        // console.log(data)
        destination.append("<div class='usage-percentage'>Disk usage: " + usagePercentage + "</div>")
        destination.append("<div class='usage-free'>Free space: " + parseFloat(data.free_gb).toFixed(2) + " GB</div>")
        destination.append("<div class='note'>Don't forget that free disk space is required for the automated backup tasks.</div>")
      }, {}, 'get')
    }, this));

    $("#db-query form").submit($.proxy(function (e) {
      e.preventDefault();
      $("#results-table-wrapper").css("opacity", 0.3);
      var url = $(e.currentTarget).attr("action");
      this.apiRequest(url, "#db-query", this.buildQueryResultsTable, {
        "offset": $("#offset", e.currentTarget).val(),
        "limit": $("#limit", e.currentTarget).val(),
        "query": $("#query", e.currentTarget).val(),
      })
    }, this));

    if ($("#db-query form").length > 0) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams.has("query")) {
        $("#db-query form #query").val(urlSearchParams.get("query"));
        $("#db-query form").submit();
      }
    }
  }

  resize() {
  }

  apiRequest(url, wrapperSelector, buildCallback, data = {}, method = "post") {
    return new Promise((resolve) => {
      // Remove current error messages
      $(".results .error-message", wrapperSelector).remove();

      // Show animation
      $(".loader", wrapperSelector).addClass("loading")

      $.ajax({
        dataType: "json",
        method: method,
        url: url,
        data: data,
        success: $.proxy(function (data) {

          // Hide animation
          $(".loader", wrapperSelector).removeClass("loading")

          // Build results page
          buildCallback(data, $(".results", wrapperSelector));
          resolve(data);
          app.anim.attach()
          app.anim.resize()

        }, this),
        error: $.proxy(function (error) {
          console.log("Error : ", data)
          // window.alert(error.responseText)

          buildCallback([], $(".results", wrapperSelector));
          resolve();

          $(".results", wrapperSelector).prepend("<div class='error-message'><span class='error-label'>Error</span><p>" + error.responseText + "</p></div>")

          // Hide animation
          $(".loader", wrapperSelector).removeClass("loading")

        }, this),
      });
    })
  }

  buildQueryResultsTable(data, destination) {

    if (table) {
      table.clear()
      table.destroy()
      table = null
    }

    if (data.length == 0) {
      $("#results-table-wrapper").html("<p class='no-result'>No data rows were returned.</p>");
      $("#results-table-wrapper").css("opacity", 1);
      return;
    }

    $("#results-table-wrapper").html("<table id=\"results-table\"></table>");

    var columns = [];
    if (data[0]) {
      $(Object.keys(data[0])).each(function (i, key) {
        columns.push({
          "title": key,
          "data": key,
          render: function (data, type, row) {
            return '<div class="td-content">' + data + "</div>";
          }
        })
      });
    }

    table = new DataTable("#results-table", {
      data: data,
      columns: columns,
      scrollX: true,
      searching: false,
      ordering: false,
      // paging: false,
      pageLength: 200,
      lengthChange: false,
      // dom: 'Bfrtip',
      dom: 'Bfiprtip',
      buttons: [
        'copy',
        // 'csv',
        // 'excel',
        // 'pdf',
        // 'print',
        'csvHtml5',
      ],
    });
    $("#results-table-wrapper").css("opacity", 1);
  }

  buildResultsPage(data, destination) {

    $(data).each(function (i, table) {

      // Skip empty table
      if (table == null) {
        return;
      }

      var box = $("<div class='box in-view' data-animation='fadeInUp' data-animation-delay='0.1s' data-animation-duration='1.7s' ></div>")
      box.append("<h3>" + stringValues(table.title) + "</h3>")

      $(table.data).each(function (i, row) {
        var field = $("<div class='field'></div>")
        field.append("<div class='field-name'>" + stringValues(row.label) + "</div>");
        if (table.wrapLabelInLink) {
          var link = window.location.pathname + "/" + field.find(".field-name").text()
          field.find(".field-name").wrapInner("<a href=" + link + "/>")
        }
        field.append("<div class='field-values'></div>")

        // Add row value
        if (!isEmptyBufferObject(row.value)) {
          field.find(".field-values").append("<div class='field-main-value'>" + stringValues(row.value) + "</div>")
        }

        // Add REPORT/AREPORT additional fields
        $(['refs', 'bibcodes', 'comment']).each(function (j, additionalField) {
          if (!isEmptyBufferObject(row[additionalField])) {
            field.find(".field-values").append("<div class='field-" + additionalField + "-value'>" + stringValues(row[additionalField]) + "</div>")
          }
        })

        // Add Associations additional fields
        $(['discovery_bibcode', 'is_real', 'coeval', 'parent_structure', 'relationships', 'physical_nature', 'bibcodes_with_membership', 'bibcodes_with_ages', 'comments']).each(function (j, additionalField) {
          if (!isEmptyBufferObject(row[additionalField])) {
            field.find(".field-values").append("<div class='field-" + additionalField + "-value'>" + stringValues(row[additionalField]) + "</div>")
          }
        })

        box.append(field)
      })

      $(destination).append(box)
    })
  }
}


function stringValues(string) {
  return (string != undefined && string != null) ? string : "";
}

function isEmptyBufferObject(object) {
  return (object != null && typeof object === "object" && object.type === "Buffer" && object.data.length <= 0);
}

